var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconJs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.3902,
    height: 64.3902,
    rx: 8,
    fill: "url(#paint0_linear_45_247)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 14H51V51H14V14ZM42.285 45.0183C40.5691 45.0183 39.5994 44.1242 38.8547 42.9062L36.0289 44.5481C37.0495 46.5646 39.1353 48.1032 42.3651 48.1032C45.6674 48.1032 48.1263 46.3889 48.1263 43.2578C48.1263 40.3548 46.4582 39.0644 43.5044 37.7956L42.6349 37.4241C41.1426 36.7766 40.4966 36.3557 40.4966 35.312C40.4966 34.4687 41.1441 33.8227 42.1616 33.8227C43.1591 33.8227 43.802 34.2436 44.3986 35.312L47.1058 33.5745C45.9603 31.5596 44.3724 30.7903 42.1616 30.7903C39.0567 30.7903 37.0695 32.776 37.0695 35.3845C37.0695 38.2134 38.7345 39.5531 41.2443 40.6215L42.1138 40.9946C43.7002 41.6883 44.6452 42.1107 44.6452 43.3025C44.6452 44.2984 43.7249 45.0183 42.285 45.0183V45.0183ZM28.8108 44.9952C27.616 44.9952 27.118 44.1781 26.5723 43.2069L23.7418 44.9212C24.562 46.6571 26.1745 48.097 28.9572 48.097C32.039 48.097 34.1496 46.4582 34.1496 42.8585V30.9876H30.6731V42.8122C30.6731 44.5497 29.9516 44.9952 28.8092 44.9952H28.8108Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_45_247",
    x1: -4.02439,
    y1: -6.03659,
    x2: 59.0244,
    y2: 72.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20BF55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01BAEF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJs);
export default __webpack_public_path__ + "static/media/icon_js.e18bb167af2e4ec23054f1586cc2d2bd.svg";
export { ForwardRef as ReactComponent };